import React from 'react';
import ReactDOM from 'react-dom';

import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/array';
import 'core-js/features/promise';
import 'isomorphic-fetch';
import 'core-js/features/object/assign';
import 'raf/polyfill';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById('root'));
registerServiceWorker();
